<template>
  <v-col>
    <v-row>
      <v-col class="device-association-title pt-0 pb-4">
        {{ $t('device.list.item.general_information') }}
      </v-col>
    </v-row>
    <v-row class="device-association-row-card">
      <v-col class="col-2">
        <div class="device-association-label mb-1">{{ $t('device.list.item.plate_number') }}</div>
        <v-text-field
          :value="props.persoDetails.vehicleInfo.vehicleLicencePlateNumber.licencePlateNumber"
          outlined
          dark
          dense
          disabled
          hide-details="auto"
        />
      </v-col>
      <v-col class="col-2">
        <div class="device-association-label mb-1">{{ $t('device.list.item.end_customer') }}</div>
        <v-text-field
          :value="props.persoDetails.customer ? props.persoDetails.customer.tspId : ''"
          outlined
          dark
          dense
          disabled
          hide-details="auto"
        />
      </v-col>
      <v-col class="col-3">
        <div class="device-association-label mb-1">{{ $t('device.list.item.country') }}</div>
        <v-text-field
          :value="props.persoDetails.vehicleInfo.vehicleLicencePlateNumber.countryCode"
          outlined
          dark
          dense
          disabled
          hide-details="auto"
        />
      </v-col>
      <v-col class="col-2">
        <div class="device-association-label mb-1">{{ $t('device.list.item.vehicle_class') }}</div>
        <v-text-field
          :value="props.persoDetails.vehicleInfo.vehicleClass"
          outlined
          dark
          dense
          disabled
          hide-details="auto"
        />
      </v-col>
      <v-col class="col-1">
        <div class="device-association-label mb-1">{{ $t('device.list.item.trailer') }}</div>
        <v-text-field
          :value="hasTrailer"
          outlined
          dark
          dense
          disabled
          hide-details="auto"
        />
      </v-col>
      <v-col class="col-2">
        <div class="device-association-label mb-1">{{ $t('map.tolldomains.global_information.service_contact') }}</div>
        <v-text-field
          :value="props.persoDetails.vehicleInfo.serviceContact"
          outlined
          dark
          dense
          disabled
          hide-details="auto"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <v-col class="device-association-title pt-6 pb-4">
            {{ $t('device.list.item.vehicle_axles') }}
          </v-col>
        </v-row>
        <v-row class="device-association-row-card">
          <v-col class="col-auto device-association-img">
            <img :src="require('@/assets/icons/vehicle/vehicle_axles_icon.svg')" alt="vehicle_axles_icon">
          </v-col>
          <v-col class="col-auto device-association-emptybox" />
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.tyre_type') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleAxles.vehicleAxlesNumber.tyreType"
              class="device-association-text-field-50"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            />
          </v-col>
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.trailer_axles') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleAxles.vehicleAxlesNumber.numberOfAxles.trailerAxles"
              class="device-association-text-field-50"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            />
          </v-col>
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.tractor_axles') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleAxles.vehicleAxlesNumber.numberOfAxles.tractorAxles"
              class="device-association-text-field-50"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col class="device-association-title pt-6 pb-4">
            {{ $t('device.list.item.weight_limit') }}
          </v-col>
        </v-row>
        <v-row class="device-association-row-card">
          <v-col class="col-auto device-association-img">
            <img :src="require('@/assets/icons/vehicle/vehicle_weight_icon.svg')" alt="vehicle_weight_icon">
          </v-col>
          <v-col class="col-auto device-association-emptybox" />
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.max_laden_weight') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleWeightLimits.vehicleMaxLadenWeight"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:append>
                <span class="device-association-unit">Kg</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.max_train_weight') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleWeightLimits.vehicleTrainMaximumWeight"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:append>
                <span class="device-association-unit">Kg</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.unladen_weight') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleWeightLimits.vehicleWeightUnladen"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:append>
                <span class="device-association-unit">Kg</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <v-col class="device-association-title pt-6 pb-4">
            {{ $t('device.list.item.vehicle_dimensions') }}
          </v-col>
        </v-row>
        <v-row class="device-association-row-card">
          <v-col class="col-auto device-association-img">
            <img :src="require('@/assets/icons/vehicle/vehicle_dimensions_icon.svg')" alt="vehicle_dimensions_icon">
          </v-col>
          <v-col class="col-auto device-association-emptybox" />
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.length_overall') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleDimensions.vehicleLengthOverall"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:append>
                <span class="device-association-unit">Dm</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.height_overall') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleDimensions.vehicleHeigthOverall"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:append>
                <span class="device-association-unit">Dm</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.width_overall') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.vehicleDimensions.vehicleWidthOverall"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            >
              <template v-slot:append>
                <span class="device-association-unit">Dm</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col class="device-association-title pt-6 pb-4">
            {{ $t('device.list.item.env_char') }}
          </v-col>
        </v-row>
        <v-row class="device-association-row-card">
          <v-col class="col-auto device-association-img">
            <img :src="require('@/assets/icons/vehicle/env_icon.svg')" alt="env_icon">
          </v-col>
          <v-col class="col-auto device-association-emptybox" />
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.euro_value') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.specificCharacteristics.environmentalCharacteristics.euroValue"
              class="device-association-text-field-20"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            />
          </v-col>
          <v-col>
            <div class="device-association-label mb-1">{{ $t('device.list.item.cop_value') }}</div>
            <v-text-field
              :value="props.persoDetails.vehicleInfo.specificCharacteristics.environmentalCharacteristics.copValue"
              class="device-association-text-field-20"
              outlined
              dark
              dense
              disabled
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="device-association-title pt-6 pb-4">
        {{ $t('map.tolldomains.legends.toll_domain') }}
      </v-col>
    </v-row>
    <v-row class="device-association-row-card">
      <v-col class="col-auto device-association-img">
        <img :src="require('@/assets/icons/vehicle/tollzones_icon.svg')" alt="tollzones_icon">
      </v-col>
      <v-col class="col-auto device-association-emptybox" />
      <v-col v-if="props.persoDetails.subscriptions.length" style="max-width: 90%">
        <div
          v-for="subscription in props.persoDetails.subscriptions"
          :key="subscription.id"
          :title="subscription.displayValue"
          class="vehicle-value vehicle-chip"
        >
          {{ subscription.displayValue }}
        </div>
      </v-col>
      <v-col v-else>
        <div class="vehicle-value vehicle-chip">
          {{ $t('common.no_data') }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="device-association-title pt-6 pb-4">
        {{ $t('device.list.item.instances') }}
      </v-col>
    </v-row>
    <v-row class="device-association-row-card">
      <v-col class="col-auto device-association-img">
        <img :src="require('@/assets/icons/vehicle/instances_icon.svg')" alt="instances_icon">
      </v-col>
      <v-col class="col-auto device-association-emptybox" />
      <v-col v-if="props.persoDetails.instances.length" class="col-auto device-instances">
        <div
          v-for="(instance) in props.persoDetails.instances"
          :key="instance"
          class="vehicle-value vehicle-chip"
          :title="instance"
        >
          {{ instance }}
        </div>
      </v-col>
      <v-col v-else>
        <div class="vehicle-value vehicle-chip">
          {{ $t('common.no_data') }}
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>
<script setup lang="ts">
import { computed, PropType } from 'vue';
import { PersonalisationDisplayDetails } from 'ctp-personalisation-search';

const props = defineProps({
  persoDetails: {
    type: Object as PropType<PersonalisationDisplayDetails>,
    default: () => ({})
  }
});

const hasTrailer = computed(() => (props.persoDetails.vehicleInfo?.vehicleAxles?.vehicleAxlesNumber?.numberOfAxles?.trailerAxles && props.persoDetails.vehicleInfo?.vehicleAxles?.vehicleAxlesNumber?.numberOfAxles?.trailerAxles > 0 ? 'Yes' : 'No'));

</script>
<style lang="scss" scoped>
@import './device-association.scss';
</style>
